import { keepPreviousData, useQuery } from '@tanstack/react-query'

import customTagsApi from '../api'

const useCustomTagData = () => {
  const { data: customTags } = useQuery({
    queryKey: [customTagsApi.fetchCustomTags.key],
    queryFn: () => customTagsApi.fetchCustomTags.fn(),
    placeholderData: keepPreviousData,
  })

  return { tags: customTags || [] }
}

export default useCustomTagData
